import React from "react";
import {
  I2cBrand,
  I2cButton,
  I2cIcon,
} from "@webcomponents/i2cwebcomponents/dist/react";
import AsideSection from "../../../Components/AsideSection/AsideSection";
// @ts-expect-error
import logo from "../../../assets/images/i2c_logo.svg";
// @ts-expect-error
import banner from "../../../assets/images/login_art.svg";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthHeadDesc from "../../../Components/SharedComponent/AuthHeaderSection/AuthHeaderSection";
import "../../../Utils/shared-styles/Authentication.scss";
import { maskEmail } from "../../../Utils/stringUtls";

const PasswordResetSuccess = () => {
  const navigate = useNavigate();
  const [searchParam, setSearchParam] = useSearchParams();
  const email = searchParam.get("email");
  return (
    <React.Fragment>
      <div className="layout_aside">
        <div className="layout_aside-left">
          <AsideSection
            image={banner}
            heading={"Transforming Visions into Realities"}
            description={`Go beyond industry standards, setting new benchmarks for success. Join us on a journey of innovation, efficiency, and client satisfaction, where every project tells a unique story.`}
          />
        </div>
        <div className="layout_aside-right forStandAlone">
          <div className="right-container">
            <div className="login  auth__main-right">
              <div className="auth__right-content">
                <div className="login__content-wrapper auth__content-wrapper reset-success">
                  <header id="header">
                    <I2cBrand
                      className="login__logo"
                      label="Client Implementation Portfolio"
                      logo={logo}
                      target=""
                    ></I2cBrand>
                  </header>
                  <AuthHeadDesc
                    title="Password Reset Successfully"
                    description="Your password has been changed successfully! You can sign in with your new password."
                  />
                  <div>
                    <div className="confirmed-email-display">
                      <I2cIcon
                        name="linear-sms"
                        className="cs-icon-shadowed"
                        variant="shadowed"
                      />
                      <span style={{ paddingLeft: "var(--i2c-spacing-6)" }}>
                        {maskEmail(email ?? "")}
                      </span>
                    </div>

                    <div className="confirmed-action-acion-button">
                      <I2cButton
                        size={"medium"}
                        className="login__sign-btn fw-500"
                        style={{ width: "100%" }}
                        onClick={() => navigate("/login")}
                      >
                        <Link
                          to={"/login"}
                          style={{
                            textDecoration: "none",
                            color: "white",
                            fontWeight: "500",
                          }}
                        >
                          Back to Login
                        </Link>
                      </I2cButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PasswordResetSuccess;
